import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "\n          業務カテゴリを変更することで、対象のお仕事を検索したり、資格登録をしたりすることができるようになります。\n        ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_InfoCard = _resolveComponent("InfoCard")!
  const _component_FormRadioGroup = _resolveComponent("FormRadioGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, _createSlots({
      default: _withCtx(() => [
        _createTextVNode("\n      業務カテゴリ設定\n    ")
      ], undefined, true),
      _: 2
    }, [
      (_ctx.showBack)
        ? {
            name: "left",
            fn: _withCtx(() => [
              _createVNode(_component_FeatherIcon, {
                icon: "chevron-left",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1024),
    _createTextVNode(),
    _createVNode(_component_CustomValidationObserver, {
      tag: "div",
      class: "my-4 mx-3",
      initialValues: { workerServiceId: _ctx.workerServiceId }
    }, {
      default: _withCtx(({ handleSubmit }) => [
        _createVNode(_component_InfoCard, { "body-class": "p-2" }, {
          default: _withCtx(() => [
            _hoisted_1
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _withDirectives(_createVNode(_component_BForm, { class: "mt-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_ValidationProvider, {
              name: "業務カテゴリ設定",
              rules: "required",
              vid: "workerServiceId"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(_component_FormRadioGroup, {
                  name: "設定値",
                  modelValue: _ctx.workerServiceId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.workerServiceId) = $event)),
                  options: _ctx.workerServiceOptions,
                  value: "value",
                  "validation-state": validationState
                }, null, 8, ["modelValue", "options", "validation-state"])
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_AppButton, {
              block: "",
              class: "mt-4",
              onClick: ($event: any) => (handleSubmit(_ctx.onSubmit))
            }, {
              default: _withCtx(() => [
                _createTextVNode("\n          設定する\n        ")
              ], undefined, true),
              _: 2
            }, 1032, ["onClick"])
          ], undefined, true),
          _: 2
        }, 1536), [
          [_vShow, _ctx.workerServiceId]
        ])
      ]),
      _: 1
    }, 8, ["initialValues"])
  ]))
}